import { HOST, } from "common/constants";
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  CircularProgress,
  Box,
  Breadcrumbs,
} from "@mui/material";
import axios from "axios";
import { ArrowRight, ChevronRight } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { BackButton } from "components/UI/BackButton";

const OrgansRegionId = () => {
  const { id } = useParams();
  const { t, i18n } = useTranslation(); // Подключаем переводчик

  const [regionData, setRegionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDistricts = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${HOST}/api/v1/districts/${id}/`
        );
        setRegionData(response.data);
      } catch (err) {
        setError(
          t("errorLoadingDistricts") || "Не удалось загрузить данные районов"
        );
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchDistricts();
  }, [id, t]);

  // Функция для динамического получения заголовка
  const getLocalizedTitle = (item) => {
    if (!item) return "";
    const lang = i18n.language;
    if (lang === "ky") return item.title_ky || item.title;
    if (lang === "en") return item.title_en || item.title_ru || item.title;
    return item.title_ru || item.title;
  };


  const getLocalizedName = (item) => {
    if (!item) return "";
    const lang = i18n.language;
    if (lang === "ky") return item.name_ky || item.name;
    if (lang === "en") return item.name_en || item.name_ru || item.name;
    return item.name_ru || item.name;
  };


  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container sx={{ mt: 4 }}>
        <Typography color="error">{error}</Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ mt: 4, mb: 4 }}>
      <BackButton />

      <Breadcrumbs separator={<ChevronRight fontSize="small" />} sx={{ mb: 2 }}>
        <Link to="/organs" style={{ textDecoration: "none", color: "inherit" }}>
          {t("msuBodies")}
        </Link>
        <Typography color="text.primary">
          {getLocalizedTitle(regionData)}
        </Typography>
      </Breadcrumbs>

      <Typography variant="h4" gutterBottom>
        {getLocalizedTitle(regionData)}
      </Typography>

      <List>
        {regionData?.municipalities.map((district) => (
          <ListItem key={district.id} disablePadding divider>
            <ListItemButton
              component={Link}
              to={`/organs/municipalities/${district.slug}`}
            >
              <ListItemText primary={getLocalizedName(district)} />
              <Box>
                <ArrowRight />
              </Box>
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      {regionData?.municipalities.length === 0 && (
        <Typography sx={{ mt: 2, color: "text.secondary" }}>
          {t("noDistrictsFound") || "В данной области районы не найдены."}
        </Typography>
      )}
    </Container>
  );
};

export default OrgansRegionId;
